module.exports = __webpack_public_path__ + "static/media/Rob-Rage-2.a2466e85.png";